import { connect, ConnectedProps } from 'react-redux'
import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import { ComponentTabObject } from '../../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../../../utils/reducers/company/workingCenters'
import { BuyTagsPayload } from '../../../../../../../../../../utils/reducers/buys/buyTags'
import { CostBuyPayload } from '../../../../../../../../../../utils/reducers/company/costsBuy'
import useBuyOrderHeaderUrls from '../../../../../../../../../../utils/hooks/buys/orders/useBuyOrderHeaderURLsN'
import BuyStepHeaderShipping from '../../../../../header/BuyHeaderShipping'
import BuyStepHeaderFinancialRows from '../../../../../header/BuyHeaderFinancialRows'
import BuyStepHeaderCosts from '../../../../../header/BuyStepHeaderCosts'
import BuyStepHeaderAccounts from '../../../../../header/BuyStepHeaderAccounts'
import BuyStepHeaderMain, { useBuyStepHeaderMainLogic } from '../../../../../header/BuyStepHeaderMain'
import { GroupVatPayload } from '../../../../../../../../../../utils/reducers/globals/groupVats'
import { EmployeesPayload } from '../../../../../../../../../../utils/reducers/company/employees'
import BuyStepHeaderVariables from '../../../../../header/BuyHeaderVariables'
import { SellVariablePayload } from '../../../../../../../../../../utils/reducers/company/sellVariables'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { useOrderITHeaderHandleChangeLogic } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/useOrderITHeaderHandleChange'
import InputTableTopHeader from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import { Fragment } from 'react'
import ModalEditOrderWorkingCenter from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditOrderWorkingCenter'
import { FormElement, FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { BuyOrderModelType } from '@teinor/erp/types/company/order/buy/buyOrder'
import ITHeaderText, { ITHeaderTextCustomer } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { InputWithLabelMargin } from '../../../../../../../../../../forms/Input'
import { sortEmployeesByUser } from '../../../../../../../../../../utils/globals/employees'
import { CustomSelectBlockedItemsSearchbar } from '../../../../../../../../../../forms/CustomSelect/CustomSelectBlockedItems'
import { notHaveCountersWorkingCenter } from '../../../../../../../../../../utils/globals/order/order'
import { parseAddressToOneLine } from '../../../../../../../../../../utils/globals/address'
import { CustomSelectWithSearchBar } from '../../../../../../../../../../forms/CustomSelect'
import { returnClassOfSpanTemplate } from '../../../../../../../../../../utils/globals/tailwind'
import { ITHeaderBuyOrderTagsNew } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components'
import { ProductTypesPayload } from '../../../../../../../../../../utils/reducers/products/productTypes'

type BuyOrderCreateStepITHeaderProps = InputTableLeftColumnCompleteRequiredProps & ReduxBuyOrderCreateStepITHeader & {}

const BuyOrderCreateStepITHeader: React.FC<BuyOrderCreateStepITHeaderProps> = ({ ...rest }) => {
    return <AppStyleDecider DefaultComponent={BuyOrderCreateStepITHeaderDefault} NewComponent={BuyOrderCreateStepITHeaderNew} {...rest} />
}
const BuyOrderCreateStepITHeaderDefault: React.FC<BuyOrderCreateStepITHeaderProps> = ({ employees, workingCenters, buyTags, groupVats, productTypes, ...rest }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useBuyOrderHeaderUrls()
    const tabs: ComponentTabObject = {
        'main': {
            component: BuyStepHeaderMain,
            text: t('dataBuy', 'Datos de la compra'),
            extraProps: { employees, workingCenters, buyTags, orderHeaderURLs }
        },
        'discounts': {
            component: BuyStepHeaderFinancialRows,
            text: t('discountsAndRecharges', 'Descuentos y recargos'),
            permission: 'buy.order',
            extraProps: { orderHeaderURLs }
        },
        'costs': {
            component: BuyStepHeaderCosts,
            text: t('costsBuy', 'Gastos de la compra'),
            permission: 'buy.order',
            extraProps: { orderHeaderURLs }
        },
        'shipping': {
            component: BuyStepHeaderShipping,
            text: t('shipping', 'Transporte'),
            permission: 'buy.order',
            extraProps: { orderHeaderURLs, groupVats }
        },
        'accounts': {
            component: BuyStepHeaderAccounts,
            text: t('divideIntoChapters', 'Dividir en capítulos'),
            permission: 'buy.order',
            extraProps: { orderHeaderURLs }
        },
        'variables': {
            component: BuyStepHeaderVariables,
            text: t('buyVariables', 'Variables de la compra'),
            permission: 'buy.order',
            extraProps: { orderHeaderURLs }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const BuyOrderCreateStepITHeaderNew: React.FC<BuyOrderCreateStepITHeaderProps> = ({ employees, workingCenters, getCompleteData, headerData, buyTags, setCompleteData, updateDataURL, ...logic }) => {
    const {t} = useTwinTranslation()
    const orderHeaderURLs = useBuyOrderHeaderUrls()
    const { handleChange } = useOrderITHeaderHandleChangeLogic({ setCompleteData, updateDataURL })
    const { activeCurrencies, changeCurrencyId, dictWarehouses, workingCenterAddress, openModal, setOpenModal, memorizedWorkingCenters, changeWorkingCenterId } = useBuyStepHeaderMainLogic({ headerData: headerData || {}, workingCenters, handleChange, setCompleteData, ...logic })

    const extraCustomer: FormElement<keyof BuyOrderModelType>[] = []
    if (headerData?.CustomerId) {
        extraCustomer.push(
            {
                name: 'CustomerId',
                component: 'Custom',
                render: () => <ITHeaderTextCustomer label={t('customer', 'Cliente')} headerData={headerData} />,
                hideSectionByDefault: true
            },
        )
    }
    const sections: FormRender<BuyOrderModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => {
                        return <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={props.onChange} defaultValue={headerData?.custom_name} className='custom_name_input_field' />
                    }
                },
                {
                    name: 'processed_date',
                    component: 'InputCalendarStateFull',
                    className: 'custom_name_input_field',
                    label: t('date', 'Fecha'),
                    onlyValids: true,
                    required: true
                },
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('representative', 'Representante'),
                    items: employees || {},
                    sortItems: true,
                    fieldName: 'fullname_short',
                    sortFunction: (emp) => sortEmployeesByUser(emp, false),
                    hideSectionByDefault: true
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('draftN', 'Nº de borrador')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA')} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'OrderTags',
                    component: 'Custom',
                    render: ({extraProps}) => {
                        return (<ITHeaderBuyOrderTagsNew getCompleteData={getCompleteData} selectedTags={headerData?.tags} dictTags={extraProps.buyTags} headerData={headerData || {}} onChange={handleChange} {...logic} className={returnClassOfSpanTemplate(3) + ' order_top_header_custom_select_tags'} />)
                    },
                    extraProps: {
                        buyTags
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'supplier_number_order',
                    component: 'InputWithLabelMargin',
                    className: 'custom_name_input_field',
                    label: t('supplierNumber', 'Número del proveedor'),
                },
                {
                    name: 'supplier_date',
                    component: 'InputCalendarStateFull',
                    className: 'custom_name_input_field',
                    label: t('dateSupplier', 'Fecha del proveedor'),
                    onlyValids: true,
                },
                {
                    name: 'supplier_assigned_number',
                    component: 'InputWithLabelMargin',
                    className: 'custom_name_input_field',
                    label: t('supplierInvoice', 'Factura del proveedor'),
                },
                ...extraCustomer,
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('billedBy', 'Facturado por')} value={headerData?.BillingWorkingCenter?.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <CustomSelectBlockedItemsSearchbar label={t('requestedBy', 'Pedido por')} items={extraProps.memorizedWorkingCenters} value={extraProps.WorkingCenterId} onChange={extraProps.changeWorkingCenterId} isStateLess={true} blockItemsFnc={extraProps.notHaveCountersWorkingCenter} sortItems={true} />
                    },
                    hideSectionByDefault: true,
                    extraProps: {
                        memorizedWorkingCenters,
                        WorkingCenterId: headerData?.WorkingCenterId,
                        changeWorkingCenterId,
                        notHaveCountersWorkingCenter
                    }
                },
                {
                    name: 'WarehouseId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('destinationWarehouse', 'Almacén destino'),
                    items: dictWarehouses,
                    hideSectionByDefault: true,
                    sortItems: true
                },
                {
                    name: 'SupplierAddress',
                    component: 'Custom',
                    render: ({ value }) => {
                        return <ITHeaderText label={t('addressSupplier', 'Dirección proveedor')} value={parseAddressToOneLine(headerData?.Supplier)} />
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'BillingAddressId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <ITHeaderText label={t('workingCenterFiscalAddress', 'Dirección Fiscal centro de trabajo')} value={extraProps.workingCenterAddress} />
                    },
                    hideSectionByDefault: true,
                    extraProps: { workingCenterAddress }
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <CustomSelectWithSearchBar label={t('currency', 'Moneda')} items={extraProps.activeCurrencies} value={extraProps.CurrencyId} onChange={extraProps.changeCurrencyId} isStateLess={true} />
                    },
                    hideSectionByDefault: true,
                    extraProps: {
                        activeCurrencies,
                        CurrencyId: headerData?.CurrencyId,
                        changeCurrencyId
                    }
                },
            ]
        }
    ]
    
    return (
        <Fragment>
            <InputTableTopHeader handleChange={handleChange} sections={sections} headerData={headerData} getCompleteData={getCompleteData} />
            {openModal?.type === 'edit' && openModal?.allRowData?.WorkingCenterId ?
                <ModalEditOrderWorkingCenter id={headerData?.id} {...{ updateWorkingCenterURL: orderHeaderURLs?.updateWorkingCenter, onSubmit: getCompleteData, setOpened: () => setOpenModal(null), allRowData: openModal?.allRowData }} />
                : null
            }
        </Fragment>
    )
}

const buyOrderCreateStepITHeaderDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setCostsBuy: (payload: CostBuyPayload) => ({ type: 'CHANGE_COSTSBUY', payload }),
    setBuyTags: (payload: BuyTagsPayload) => ({ type: 'CHANGE_BUY_TAGS', payload }),
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
    setSellVariables: (payload: SellVariablePayload) => ({ type: 'CHANGE_SELLVARIABLE', payload }),
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxBuyOrderCreateStepITHeader = ConnectedProps<typeof buyOrderCreateStepITHeaderConnect>
const mapBuyOrderCreateStepITHeaderConnector = (state: AllReduxPayloads) => ({ employees: state.employees, workingCenters: state.workingCenters, costsBuy: state.costsBuy, buyTags: state.buyTags, groupVats: state.groupVats, sellVariables: state.sellVariables, productTypes: state.productTypes })
const buyOrderCreateStepITHeaderConnect = connect(mapBuyOrderCreateStepITHeaderConnector, buyOrderCreateStepITHeaderDispatch)
const buyOrderCreateStepITHeaderConnectLoading = withLoading(BuyOrderCreateStepITHeader, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/cost/costBuy/getAllCostBuys', propName: 'costsBuy', setFunctionName: 'setCostsBuy' }, { fetchUrl: '/api/app/order/buy/tag/getAllBuyTags', propName: 'buyTags', setFunctionName: 'setBuyTags' }, { fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }, { fetchUrl: '/api/app/config/sell/sellVariable/getAllSellVariables', propName: 'sellVariables', setFunctionName: 'setSellVariables' }, { fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' } ])
const BuyOrderCreateStepITHeaderConnect = buyOrderCreateStepITHeaderConnect(buyOrderCreateStepITHeaderConnectLoading)

export default BuyOrderCreateStepITHeaderConnect